import { ApplicationCode } from "constants/auth";

import {
  FileSearch02Icon,
  HomeLineIcon,
  Settings01Icon,
  SidebarMenuItem,
} from "components";
import Edit04 from "components/Icon/Edit04";
import { Paths } from "configs";
import { getCanAccess } from "hooks/useEnforcer";

export interface SidebarMenuRoute extends SidebarMenuItem {
  permissions?: Array<string> | null;
  children?: Array<SidebarMenuRoute>;
}

export const SidebarMenuRoutes: Array<SidebarMenuRoute> = [
  {
    id: "reportManagement",
    title: "Report Management",
    path: Paths.App,
    icon: HomeLineIcon,
    hideInMenu: !getCanAccess([ApplicationCode.Report]),
  },
  {
    id: "requestManagement",
    title: "Request Management",
    path: Paths.requestGridPath,
    icon: FileSearch02Icon,
    hideInMenu: !getCanAccess([ApplicationCode.Request]),
    children: [
      {
        id: "requestManagement",
        title: "Request Checklist Management",
        path: Paths.requestGridPath,
        icon: FileSearch02Icon,
        hideInMenu: true,
      },
      {
        id: "requestManagementCreate",
        title: "Create Request Check",
        path: Paths.requestCreatePath,
        icon: FileSearch02Icon,
        hideInMenu: true,
      },
      {
        id: "requestManagementUpdate",
        title: "Update Request Check",
        path: Paths.requestUpdatePath,
        icon: FileSearch02Icon,
        hideInMenu: true,
      },
      {
        id: "requestManagementDetail",
        title: "Detail Request Check",
        path: Paths.requestDetailPath,
        icon: FileSearch02Icon,
        hideInMenu: true,
      },
    ],
  },
];

export const SidebarBottomMenuRoutes: Array<SidebarMenuRoute> = [
  {
    id: "Settings",
    title: "Settings",
    icon: Settings01Icon,
    children: [
      {
        id: "ChangePassword",
        title: "Change password",
        path: Paths.resetPasswordPath,
        icon: Edit04,
      },
    ],
  },
];
